<div
  class="flex-control flex-column flex-height"
  style="min-width: 0; min-height: 0;">

  <div class="flex-header" style="flex-shrink: 0;">
    <h4 class="m0">{{amenity.id ? 'Edit' : 'Add'}} Service</h4>
  </div>

  <form
    (ngSubmit)="save()"
    #amenityForm="ngForm"
    class="flex-body"
    style="display: flex; flex-direction: column; min-width: 0; min-height: 0;">

    <div
      class="flex-control flex-column"
      style="flex: 1 1 auto; min-width: 0; min-height: 0;">

      <div
        class="flex-body scroll-browser main-wrapper"
        style="min-width: 0; min-height: 0; overflow-y: auto;">

        <div class="row form-group">
          <div class="col-md-2 col-sm-3">
            <label>Name*</label>
          </div>

          <div class="col-md-4 col-sm-9">
            <input
              type="text"
              class="form-control"
              placeholder="Name of Service"
              [(ngModel)]="amenity.name"
              name="name"
              required>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-2 col-sm-3">
            <label>Method*</label>
          </div>

          <div class="col-md-4 col-sm-9">
            <ss-multiselect-dropdown
              style="display: block; width: 100%; min-width: 0;"
              [options]="methodOptions"
              [(ngModel)]="selected_method"
              name="m"
              [settings]="mySettings"
              (ngModelChange)="addMethodArray($event)"
              required>
            </ss-multiselect-dropdown>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-2 col-sm-3">
            <label>Short description</label>
          </div>

          <div class="col-md-8 col-sm-9">
            <editor
              #shoteditor
              style="display: block; width: 100%; min-width: 0;"
              apiKey="no-api-key"
              id="shot_description"
              name="shot_description"
              [(ngModel)]="amenity.short_description"
              [init]="init_tiny">
            </editor>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-2 col-sm-3">
            <label>Full Description</label>
          </div>

          <div class="col-md-8 col-sm-9">
            <editor
              #editor
              style="display: block; width: 100%; min-width: 0;"
              apiKey="no-api-key"
              id="summary"
              name="mesage_body"
              [(ngModel)]="amenity.long_description"
              [init]="init_tiny">
            </editor>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-2 col-sm-3">
            <label>No of booking/day</label>
          </div>

          <div class="col-md-3 col-sm-9">
            <input
              type="number"
              class="form-control"
              placeholder="No of booking/day"
              [(ngModel)]="amenity.no_of_bookings_per_day"
              name="no_of_booking">
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-2 col-sm-3">
            <label>Duration</label>
          </div>

          <div class="col-md-3 col-sm-9">
            <div style="display: flex; align-items: center; gap: 8px;">
              <input
                type="number"
                class="form-control"
                style="flex: 1 1 0; min-width: 0;"
                placeholder="Duration"
                [(ngModel)]="amenity.duration"
                name="duration">

              <span style="flex-shrink: 0;">min</span>
            </div>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-2 col-sm-3">
            <label>Offset</label>
          </div>

          <div class="col-md-4 col-sm-9">
            <div style="display: flex; align-items: center; gap: 8px;">
              <input
                type="number"
                class="form-control"
                style="flex: 1 1 0; min-width: 0;"
                placeholder="Offset Time"
                [(ngModel)]="amenity.offset_time"
                name="offset_time">

              <select
                name="offset_type"
                [(ngModel)]="amenity.offset_type"
                class="form-control"
                style="flex: 0 0 90px; width: 90px;">
                <option value="mins">Min</option>
                <option value="hours">Hour</option>
              </select>
            </div>
          </div>
        </div>

        <ng-container *ngFor="let method of amenity.amenity_methods">
          <div class="row form-group">
            <div class="col-md-2 col-sm-3">
              <label>{{method.name}} Fee*</label>
            </div>

            <div class="col-md-3 col-sm-9">
              <div style="display: flex; align-items: center; gap: 8px;">
                <input
                  type="number"
                  class="form-control"
                  style="flex: 1 1 0; min-width: 0;"
                  placeholder="Fee"
                  [(ngModel)]="method.fee"
                  name="{{method.name}}"
                  required>

                <span style="flex-shrink: 0;">$</span>
              </div>
            </div>
          </div>
        </ng-container>

        <div class="row form-group">
          <div class="col-md-2 col-sm-3">
            <label>Auto Acknowledge</label>
          </div>

          <div class="col-md-2 col-sm-9">
            <input
              type="checkbox"
              name="auto_acknowledge"
              [(ngModel)]="amenity.auto_acknowledge">
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-2 col-sm-3">
            <label>Payment Method *</label>
          </div>

          <div class="col-md-10 col-sm-9 col-xs-12">
            <div
              style="display: flex; flex-wrap: wrap; align-items: center; gap: 10px;">

              <label
                class="white-container-box fw-500 mr-lg"
                style="display: inline-flex; align-items: center; margin: 0;">
                Insurance
                <input
                  type="radio"
                  class="ml"
                  style="flex-shrink: 0;"
                  name="all_patients"
                  value="insurance"
                  [(ngModel)]="amenity.payment_method"
                  required>
              </label>

              <label
                class="white-container-box fw-500 mr-lg"
                style="display: inline-flex; align-items: center; margin: 0;">
                Self-Pay
                <input
                  type="radio"
                  class="ml"
                  style="flex-shrink: 0;"
                  name="customized_patients"
                  value="self_pay"
                  [(ngModel)]="amenity.payment_method"
                  required>
              </label>

              <label
                class="white-container-box fw-500 mr-lg"
                style="display: inline-flex; align-items: center; margin: 0;">
                Both
                <input
                  type="radio"
                  class="ml"
                  style="flex-shrink: 0;"
                  name="customized_patients"
                  value="both"
                  [(ngModel)]="amenity.payment_method"
                  required>
              </label>
            </div>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-2 col-sm-3">
            <label>Type of Patients</label>
          </div>

          <div class="col-md-10 col-sm-9 col-xs-12">
            <div
              style="display: flex; flex-wrap: wrap; align-items: center; gap: 10px;">

              <label
                class="white-container-box fw-500 mr-lg"
                style="display: inline-flex; align-items: center; margin: 0;">
                All Patients
                <input
                  type="radio"
                  class="ml"
                  style="flex-shrink: 0;"
                  name="applicable_to_all_patients"
                  value="all_patients"
                  [(ngModel)]="amenity.applicable_patients">
              </label>

              <label
                class="white-container-box fw-500 mr-lg"
                style="display: inline-flex; align-items: center; margin: 0;">
                New Patients
                <input
                  type="radio"
                  class="ml"
                  style="flex-shrink: 0;"
                  name="applicable_to_new_patients"
                  value="new_patients"
                  [(ngModel)]="amenity.applicable_patients">
              </label>

              <label
                class="white-container-box fw-500 mr-lg"
                style="display: inline-flex; align-items: center; margin: 0;">
                Existing Patient
                <input
                  type="radio"
                  class="ml"
                  style="flex-shrink: 0;"
                  name="applicable_to_existing_patient"
                  value="existing_patient"
                  [(ngModel)]="amenity.applicable_patients">
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="flex-footer " >
        <div class="row ml0 mr0 form-group">
          <div class="col-md-2 col-sm-3"></div>

          <div class="col-md-8 col-sm-9">
            <div  style="display: flex; flex-wrap: wrap; align-items: center; gap: 10px;">
              <a
                *ngIf="loaderService.uploading_in_process"
                class="btn btn-default"
                style="max-width: 100%; white-space: normal;">
                <i class="fa fa-spinner fa-spin fs16 vl-m mr-sm"></i>
                Uploading...
              </a>

              <button
                type="submit"
                class="btn btn-secondary mr"
                style="max-width: 100%; white-space: normal; margin-right: 0;"
                [disabled]="!amenityForm.form.valid"
                *ngIf="!loaderService.uploading_in_process">
                {{amenity.id ? 'Update' : 'Save'}} to Continue
              </button>

              <button
                class="btn btn-tertiary btn-outline mr"
                style="max-width: 100%; white-space: normal; margin-right: 0;"
                (click)="closeNewForm()">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
